import PawsLayout from "@/layouts/paws/index";
import NavigationElement from "@/components/navigation-element/index";

import NAVIGATION_MOBILE from "@/data/navigation-mobile.yaml";
import NAVIGATION from "@/data/navigation.yaml";

export default {
  components: { PawsLayout, NavigationElement },
  data() {
    return {
      navigationElements: NAVIGATION,
      mobileNavigationElements: NAVIGATION_MOBILE,
    };
  },
};
